const systemRoutes = [
  {
    path: 'system-maintenance-review',
    name: 'system-maintenance-review',
    meta: {
      title: '系统维护审查',
      requiresAuth: true,
      nav: false
    },
    component: resolve => require(['../views/page/system/system-maintenance-review.vue'], resolve)
  },
  {
    path: 'system-operation-log',
    name: 'system-operation-log',
    meta: {
      title: '系统操作日志',
      requiresAuth: true,
      nav: false
    },
    component: resolve => require(['../views/page/system/system-operation-log.vue'], resolve)
  },
  {
    path: 'system-error-log',
    name: 'system-error-log',
    meta: {
      title: '系统错误日志',
      requiresAuth: true,
      nav: false
    },
    component: resolve => require(['../views/page/system/system-error-log.vue'], resolve)
  },
  {
    path: 'system/modify-stop-time',
    name: 'modify-stop-time',
    meta: {
      title: '修改停嘱时间',
      requiresAuth: true,
      nav: false
    },
    component: resolve => require(['../views/page/system/modify-stop-time.vue'], resolve)
  },
  {
    path: 'system/sycn-code-inpatient',
    name: 'sycn-code-inpatient',
    meta: {
      title: '同步医保编码(住院)',
      requiresAuth: true,
      nav: false
    },
    component: resolve => require(['../views/page/system/sycn-code-inpatient.vue'], resolve)
  },
  {
    path: 'system/function-management',
    name: 'function-management',
    meta: {
      title: '功能管理',
      requiresAuth: true,
      nav: false
    },
    component: resolve => require(['../views/page/system/function-management.vue'], resolve)
  },
  {
    path: 'system/configuration-item',
    name: 'configuration-item',
    meta: {
      title: '配置项管理',
      requiresAuth: true,
      nav: false
    },
    component: resolve => require(['../views/page/system/configuration-item.vue'], resolve)
  },
  {
    path: 'system/update-drug-code',
    name: 'update-drug-code',
    meta: {
      title: '追溯码补传信息导入',
      requiresAuth: true,
      nav: false
    },
    component: resolve => require(['../views/page/system/update-drug-code.vue'], resolve)
  }
]

export default systemRoutes
